/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import {Accordion, Button, Container, Modal, Table} from "react-bootstrap";
import i18n from "../../plugins/locale/i18n";
import loadDictionary from "../../plugins/locale/load-dictionary";
import PaymentOrderService from "../../service/payment-order-service";
import Pasoonate from "pasoonate";

const paymentOrderService = new PaymentOrderService();

await loadDictionary('payment-order-show-window');
await loadDictionary("payment-methods");
await loadDictionary("payment-reasons");

function ShowPaymentOrderWindow({isOpenWindow, onCloseWindow, paymentOrderId}) {
  const [paymentOrder, setPaymentOrder] = useState(null);

  const handleClose = () => { 
    onCloseWindow();
  };

  useEffect(() => {
    if(!isOpenWindow || !paymentOrderId) return;
   
    paymentOrderService.details(paymentOrderId).then(paymentOrder => {
      paymentOrder.due_date = paymentOrder?.due_date ? Pasoonate.make().gregorian().parse('yyyy-MM-dd HH:mm:ss', paymentOrder.due_date) : null;
      paymentOrder.created_at = paymentOrder?.created_at ? Pasoonate.make().gregorian().parse('yyyy-MM-dd HH:mm:ss', paymentOrder.created_at) : null;

      setPaymentOrder(paymentOrder);
    });

  }, [isOpenWindow, paymentOrderId]);

  return (
    <Modal show={isOpenWindow} onHide={handleClose} backdrop="static" keyboard={true} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{i18n.t("payment-order-show-window.title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <p><b>{i18n.t("payment-order-show-window.party")}:</b> {paymentOrder?.party?.name}</p>
          <p><b>{i18n.t("payment-order-show-window.party_bank_account")}:</b> {paymentOrder?.party_bank_account.name}</p>
          <div className="row">
            <p className="col-12 col-sm-6"><b>{i18n.t("payment-order-show-window.due_date")}:</b> <span dir="ltr">{paymentOrder?.due_date.jalali().format('yyyy/MM/dd')}</span></p>
            <p className="col-12 col-sm-6"><b>{i18n.t("payment-order-show-window.creation_date")}:</b> <span dir="ltr">{paymentOrder?.created_at.jalali().format('yyyy/MM/dd HH:mm:ss')}</span></p>
          </div>
          <p><b>{i18n.t("payment-order-show-window.description")}:</b> {paymentOrder?.description}</p>
          <p className="text-center fs-4">{Number(paymentOrder?.amount).toLocaleString()} {i18n.t("global.rial")}</p>
        </div>
        <Accordion defaultActiveKey="0">
          {paymentOrder?.receipts?.map((receipt, index) => (
            <Accordion.Item key={index} eventKey={index}>
              <Accordion.Header>
                <Container fluid>
                <div className="row">
                  <div className="col"><p className="small mb-2 text-secondary">{i18n.t("payment-order-show-window.origin_bank_account")}</p> {receipt.origin_bank_account.name}</div>
                  <div className="col-3"><p className="small mb-2 text-secondary">{i18n.t("payment-order-show-window.payment_method")}</p>{i18n.t(`payment-methods.${receipt.payment_method}`)}</div>
                  <div className="col-3"><p className="small mb-2 text-secondary">{i18n.t("payment-order-show-window.status")}</p>{i18n.t(`global.receiptStatus.${receipt.status}`)}</div>
                </div>
                {/* <div className="row mt-3">
                  <div className="col-12"><span dir="ltr">{Pasoonate.make().gregorian().parse('yyyy-MM-dd HH:mm:ss', receipt.created_at).jalali().format('yyyy/MM/dd HH:mm:ss')}</span></div>
                </div> */}
                </Container>
              </Accordion.Header>
              <Accordion.Body>
                <div className="table-responsive">
                  <Table>
                    <thead>
                      <tr>
                        <th>{i18n.t("payment-order-show-window.transaction.id")}</th>
                        <th>{i18n.t("payment-order-show-window.transaction.reference_number")}</th>
                        <th>{i18n.t("payment-order-show-window.transaction.created_at")}</th>
                        <th>{i18n.t("payment-order-show-window.transaction.status")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {receipt?.transactions?.map((transaction, index) => (
                        <tr key={index}>
                          <td>{transaction.id}</td>
                          <td>{transaction.reference_number}</td>
                          <td><span dir="ltr">{Pasoonate.make().gregorian().parse('yyyy-MM-dd HH:mm:ss', transaction.created_at).jalali().format('yyyy/MM/dd HH:mm:ss')}</span></td>
                          <td>{i18n.t(`global.transactionStatus.${transaction.status}`)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          ))}  
        </Accordion>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>{i18n.t("payment-order-show-window.close_button")}</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ShowPaymentOrderWindow;